module.exports = __webpack_public_path__ + "static/media/airplane2.b2482404.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/airplane2.svg
// module id = 2252
// module chunks = 7